import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { APPLICATION_PROPERTY_GET_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetApplicationProperty extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = APPLICATION_PROPERTY_GET_URL;

  constructor(reqData) {
    super();
    const { applicationId } = reqData;
    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
